import { IDailyForecastData } from "@/types/daily-forecast-type";

import WeatherWithIcon from "../../weather-with-icon/WeatherWithIcon";

import "./style.scss";

interface IDataExtend extends IDailyForecastData {
	dayWeek: string;
	day: string;
}

type ForecastCardProps = {
	updateDateStore: (dateString: string) => void;
	isActive: boolean;
	image?: React.ReactNode;
	data: IDataExtend;
	date: string;
	type: "marine" | "world" | "weather";
};

export const ForecastCard = ({
	updateDateStore,
	image,
	isActive,
	data,
	date,
	type,
}: ForecastCardProps) => {
	return (
		<div className="card-weather" onClick={() => updateDateStore(data.dayWeek)}>
			<div className={`card-content ${!isActive && "disabled"}`}>
				<div className="weather-top">
					<WeatherWithIcon
						type={type}
						tempMax={data.temperature_max ?? "-"}
						tempMin={data.temperature_min ?? "-"}
						icon={image}
					/>
				</div>
				<div className="date-card">
					<p>{data.day}</p>
					<p>{data.dayWeek}</p>
				</div>
			</div>

			{date === data.dayWeek && <span className="active-bar"></span>}
		</div>
	);
};

export default ForecastCard;
